import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./ContextAgentAttentionBubble.css";

/**
 * Speech-style nudge above a context-agent launcher. Click opens the chat panel.
 */
export default function ContextAgentAttentionBubble({
  message,
  placement = "top",
  exiting = false,
  onClick,
  onDismiss,
  onAnimationEnd,
}) {
  if (!message) {
    return null;
  }

  return (
    <div
      className={[
        "context-agent-attention-bubble",
        `context-agent-attention-bubble--${placement}`,
        exiting ? "context-agent-attention-bubble--exit" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onAnimationEnd={onAnimationEnd}
      data-testid="context-agent-attention-bubble"
    >
      <button
        type="button"
        className="context-agent-attention-bubble__body"
        onClick={onClick}
        onPointerDown={(event) => event.stopPropagation()}
        onPointerUp={(event) => event.stopPropagation()}
        aria-label={message}
      >
        <span className="context-agent-attention-bubble__text">{message}</span>
      </button>
      <button
        type="button"
        className="context-agent-attention-bubble__close"
        onClick={onDismiss}
        onPointerDown={(event) => event.stopPropagation()}
        onPointerUp={(event) => event.stopPropagation()}
        aria-label="Dismiss greeting"
        data-testid="context-agent-attention-bubble-dismiss"
      >
        <CloseIcon sx={{ fontSize: 14 }} />
      </button>
    </div>
  );
}
